import { apiClient } from './api.client';
import { API_ENDPOINTS } from '../config/api.config';
import { VehicleExpense, TripFinancialSummary } from '../types';

export const tripFinanceService = {
  // Get all expenses for a trip (both allowances and expenses)
  getExpensesByTrip: async (tripId: number): Promise<VehicleExpense[]> => {
    const response = await apiClient.get<VehicleExpense[]>(API_ENDPOINTS.TRIP_EXPENSES.BY_TRIP(tripId));
    return response.data;
  },

  // Get trip allowances (filtered by allowance categories)
  getAllowancesByTrip: async (tripId: number): Promise<VehicleExpense[]> => {
    const response = await apiClient.get<VehicleExpense[]>(API_ENDPOINTS.TRIP_ALLOWANCES.BY_TRIP(tripId));
    return response.data;
  },

  // Get trip costs (filtered by expense categories)
  getCostsByTrip: async (tripId: number): Promise<VehicleExpense[]> => {
    const response = await apiClient.get<VehicleExpense[]>(`/api/trips/${tripId}/costs`);
    return response.data;
  },

  // Financial Summary
  getFinancialSummary: async (tripId: number): Promise<TripFinancialSummary> => {
    const response = await apiClient.get<TripFinancialSummary>(API_ENDPOINTS.TRIP_FINANCE.SUMMARY(tripId));
    return response.data;
  },
};
